module.exports = __webpack_public_path__ + "static/media/rotate-right.7351fcee.svg";